<div class="dialog-wrapper">
  <div class="title-row" mat-dialog-titled fxLayout="row" fxLayoutAlign=" center">
    <h2 mat-dialog-title>
      <div class="title">{{ title | translate }}</div>
    </h2>
    <span class="close-btn" (click)="dialogRef.close()"><mat-icon>close</mat-icon></span>
  </div>
  <mat-dialog-content>
    <div>
      <span #target></span>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button class="secondary-button" mat-dialog-close>{{ "generic.cancel" | translate }}</button>
    <button mat-stroked-button class="primary-button" accesskey="s" [innerHTML]="buttontext | translate" (click)="submit()"></button>
  </mat-dialog-actions>
</div>
